import React from 'react'
import PropTypes from 'prop-types'
import {Box, Flex, Img, Link, useMultiStyleConfig} from '@chakra-ui/react'
import useDamImage from '../../../custom-hooks/use-dam-image'
import {useGetCategoriesData} from '../../../custom-api/hooks/use-get-categories-data'
import {getGlobalLink} from '../../../utils/contentstack-utils'
import {remCalc} from '../../../theme/_utils'
import useMultiSite from '@salesforce/retail-react-app/app/hooks/use-multi-site'

export const Disclaimer = ({
    bodycopy,
    heading = '',
    icon,
    links = [],
    maxWidth = remCalc(1920),
}) => {
    const styles = useMultiStyleConfig('Disclaimer')

    const damImage = useDamImage(icon)

    const categoryData = useGetCategoriesData()
    const {locale} = useMultiSite()
    const renderedLinks =
        links?.length === 0
            ? []
            : links?.map((link, index) => {
                  const {url, label, isAbsolute} = getGlobalLink(
                      link,
                      categoryData,
                      locale?.alias || locale?.id,
                  )
                  return (
                      <Link
                          key={`disclaimer-link-${index}`}
                          href={url}
                          isExternal={isAbsolute}
                          {...styles.anchor}
                      >
                          {label}
                      </Link>
                  )
              })

    return (
        <Box {...styles.container} maxW={maxWidth}>
            <Flex {...styles.grid} direction={{lg: 'row', base: 'column'}}>
                {damImage.url && (
                    <Box {...styles.icon}>
                        <Img src={damImage.url} alt={icon?.alt || ''}></Img>
                    </Box>
                )}
                <Flex {...styles.content}>
                    {heading && (
                        <Box {...styles.heading} fontWeight={'medium'}>
                            {heading}
                        </Box>
                    )}
                    <Box
                        data-testid="disclaimer-bodycopy"
                        {...styles.bodycopy}
                        dangerouslySetInnerHTML={{__html: bodycopy}}
                    />
                    {renderedLinks.length > 0 && <Flex {...styles.links}>{renderedLinks}</Flex>}
                </Flex>
            </Flex>
        </Box>
    )
}

Disclaimer.propTypes = {
    heading: PropTypes.string,
    bodycopy: PropTypes.string,
    icon: PropTypes.shape(),
    links: PropTypes.arrayOf(PropTypes.shape()),
    maxWidth: PropTypes.string,
}
